import React, { createContext, useContext, useMemo } from "react";
import { ACCENTS } from "../../core/constants";
import { getAccentPresetFromRuntime, getGlowAlpha } from "../../core/theme";
import { hexToRgba } from "../../core/color";

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const value = useMemo(() => {
    const accentPreset = getAccentPresetFromRuntime();
    const acc = ACCENTS[accentPreset] || ACCENTS["teal-blue"];
    const g = getGlowAlpha();
    return {
      ...acc,
      accentPreset,
      glowAlpha: g,
      glow: (color, radius = 20) => `0 0 ${radius}px ${hexToRgba(color, g)}`,
      glowBorder: (color) =>
        `0 0 12px ${hexToRgba(color, g * 0.8)}, inset 0 0 12px ${hexToRgba(color, 0.1)}`,
    };
  }, []);

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useAccent() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useAccent must be used within ThemeProvider");
  return ctx;
}
